import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { c as n } from "../../../../clsx-OuTLNxxd.js";
import { forwardRef as S } from "react";
import { I as b } from "../../../../icon-BnqXyiyH.js";
import "../../icon/iconsList.js";
import { INPUT_STATUS as _, ICONS_STATUS as p } from "./input.type.js";
const T = "_input_1r0sy_29", U = "_filled_1r0sy_47", r = {
  input: T,
  "group-label": "_group-label_1r0sy_29",
  filled: U,
  "is-error": "_is-error_1r0sy_50",
  "is-success": "_is-success_1r0sy_53",
  "is-warning": "_is-warning_1r0sy_56",
  "helper-text": "_helper-text_1r0sy_59",
  "is-disabled": "_is-disabled_1r0sy_86",
  "is-full-width": "_is-full-width_1r0sy_101",
  "container-icon": "_container-icon_1r0sy_145",
  "dialog-overlay-show": "_dialog-overlay-show_1r0sy_1",
  "dialog-content-show": "_dialog-content-show_1r0sy_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1r0sy_1"
}, j = S(
  ({
    className: t,
    type: m = "text",
    value: h,
    message: c,
    status: i,
    placeholder: y,
    onChange: f,
    disabled: s,
    label: o,
    helperText: d,
    name: u,
    isFullWidth: w,
    defaultValue: N,
    id: g,
    optionalMessage: a,
    ...v
  }, x) => {
    const I = n(
      r.input,
      i && r[_[i]],
      s && r["is-disabled"],
      w && r["is-full-width"],
      t
    );
    return /* @__PURE__ */ e("div", { className: I, children: [
      /* @__PURE__ */ e("div", { className: r["group-label"], children: [
        /* @__PURE__ */ e("div", { children: [
          o && /* @__PURE__ */ l("label", { className: n(i && r[i]), children: o }),
          a && /* @__PURE__ */ l("span", { children: a })
        ] }),
        d && /* @__PURE__ */ l("div", { className: r["helper-text"], children: d })
      ] }),
      /* @__PURE__ */ l(
        "input",
        {
          id: g,
          ref: x,
          value: h,
          className: n(i && !s && r[_[i]]),
          type: m,
          placeholder: y,
          onChange: f,
          name: u,
          defaultValue: N,
          "aria-label": o,
          ...v
        }
      ),
      c && i && !s && /* @__PURE__ */ e("div", { className: r["container-icon"], children: [
        /* @__PURE__ */ l(b, { name: p[i].name, size: "medium", color: p[i].color }),
        /* @__PURE__ */ l("span", { className: r[_[i]], children: c })
      ] })
    ] });
  }
);
j.displayName = "Input";
export {
  j as Input
};
